module.exports = __webpack_public_path__ + "static/media/login-bg.ba357761.png";